export interface CatalogAccessSettingsConstructor {
  rfoLockDefault: boolean
  catalogPermissionEnabled: boolean
}

export class CatalogAccessSettings {
  readonly rfoLockDefault: boolean
  readonly catalogPermissionEnabled: boolean

  constructor(data: CatalogAccessSettingsConstructor) {
    this.rfoLockDefault = data.rfoLockDefault
    this.catalogPermissionEnabled = data.catalogPermissionEnabled
  }
}
